import AttendAchievementLockForm from './AttendAchievementLockForm';

export default AttendAchievementLockForm;
